import { Box, Button, Divider, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { cancelDeformedPreview } from '~/hooks/viewer/useDeformedPreview';
import {
    deformedPreviewCoverageState,
    deformedPreviewProgressState,
} from '~/state/atoms/deformedPreviewAtoms';

export default function DeformedPreviewSection() {
    const progress = useRecoilValue(deformedPreviewProgressState);
    const fieldCoverage = useRecoilValue(deformedPreviewCoverageState);
    if (!progress && fieldCoverage === null) {
        return null;
    }
    return (
        <>
            <Divider />
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    px: 0.25,
                }}
            >
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ flex: 1 }}
                >
                    <FormattedMessage id="registrationQa.preview.label" />
                </Typography>
                {progress && (
                    <>
                        <Typography variant="caption" color="text.secondary">
                            <FormattedMessage
                                id="registrationQa.preview.progress"
                                values={{
                                    done: progress.done,
                                    total: progress.total,
                                }}
                            />
                        </Typography>
                        <Button
                            size="small"
                            onClick={cancelDeformedPreview}
                            data-testid="deformed-preview-cancel"
                        >
                            <FormattedMessage id="cancel" />
                        </Button>
                    </>
                )}
            </Box>
            {fieldCoverage !== null && !progress && (
                <Typography
                    variant="caption"
                    color={
                        fieldCoverage < 1 ? 'warning.main' : 'text.secondary'
                    }
                    sx={{ display: 'block', px: 0.25 }}
                    data-testid="deformed-preview-coverage"
                >
                    <FormattedMessage
                        id="registrationQa.preview.coverage"
                        values={{ percent: Math.round(fieldCoverage * 100) }}
                    />
                </Typography>
            )}
        </>
    );
}
